import {useTownhallTemplate} from 'Event/template/Townhall'
import {useSaveTemplate} from 'Event/TemplateUpdateProvider'
import HTMLEditor, {HTMLEditorContainer} from 'lib/ui/form/HTMLEditor'
import Title from 'lib/ui/ConfigPanel/Title'
import TextField from 'lib/ui/TextField'
import {useConfig} from 'organization/Event/Configurable'
import Config from 'organization/Event/Configurable/Config'
import SettingsPanel from 'organization/Event/DashboardConfig/ComponentConfigPanel/SettingsPanel'
import StylingPanel from 'organization/Event/DashboardConfig/ComponentConfigPanel/StylingPanel'
import React from 'react'
import {Controller} from 'react-hook-form'
import {useAddTranslation} from 'Event/LanguageProvider'
import {useAttendeeVariables} from 'Event'
import {replaceAtPath} from 'lib/JsonUpdateProvider'
import {TemplateSave} from 'Event/TemplateUpdateProvider'
import {Template} from 'Event/template'
import Styling from 'Event/template/Townhall/FAQs/Styling'

export default function FaqsHeaderConfig() {
  const save = useSaveTemplate()
  const {faq} = useTownhallTemplate()
  const addTranslation = useAddTranslation()
  const v = useAttendeeVariables()
  const {
    form: {register, control},
  } = useConfig()

  const handleSave: TemplateSave<Template> = (data) => {
    const title = replaceAtPath(data, 'faq.title', '{{faq_title}}')

    const description = replaceAtPath(
      data,
      'faq.description',
      '{{faq_description}}',
    )

    const secondaryTitle = replaceAtPath(
      data,
      'faq.secondaryTitle',
      '{{faq_secondary_title}}',
    )

    save({
      ...data,
      localization: addTranslation({
        faq_title: title || 'Faq',
        faq_description: description || '',
        faq_secondary_title: secondaryTitle || '',
      }),
    })
  }
  return (
    <Config title="Header" onSave={handleSave}>
      <SettingsPanel>
        <TextField
          name="faq.title"
          defaultValue={v(faq.title)}
          label="Title"
          fullWidth
          inputProps={{
            'aria-label': 'faq page title',
            ref: register,
          }}
        />
        <TextField
          name="faq.secondaryTitle"
          defaultValue={v(faq.secondaryTitle)}
          label="Secondary Title"
          fullWidth
          inputProps={{
            'aria-label': 'faq secondary title',
            ref: register,
          }}
        />
        <Title>Description</Title>
        <Controller
          name="faq.description"
          defaultValue={v(faq.description)}
          control={control}
          render={({onChange, value}) => (
            <HTMLEditorContainer>
              <HTMLEditor data={value} onChange={onChange} />
            </HTMLEditorContainer>
          )}
        />
      </SettingsPanel>
      <StylingPanel>
        <Styling />
      </StylingPanel>
    </Config>
  )
}
